export const DOMAIN = 'formData';

export const UPDATE_OCCUPIED_COST_ROOM_BREAKDOWN_VALUE = 'app/formData/UPDATE_OCCUPIED_COST_ROOM_BREAKDOWN_VALUE';
export const UPDATE_OCCUPIED_COST_FORM_VALUE = 'app/formData/UPDATE_OCCUPIED_COST_FORM_VALUE';
export const UPDATE_OCCUPIED_COST_SECTION = 'app/formData/UPDATE_OCCUPIED_COST_SECTION';
export const UPDATE_PACKAGE_CALCULATOR_FORM_VALUE = 'app/formData/UPDATE_PACKAGE_CALCULATOR_FORM_VALUE';
export const UPDATE_PACKAGE_CALCULATOR_INCLUSIONS_VALUE = 'app/formData/UPDATE_PACKAGE_CALCULATOR_INCLUSIONS_VALUE';
export const UPDATE_PACKAGE_CALCULATOR_INCREMENTS = 'app/formData/UPDATE_PACKAGE_CALCULATOR_INCREMENTS';
export const UPDATE_GROUP_DISPLACEMENT_FORM_VALUE = 'app/formData/UPDATE_GROUP_DISPLACEMENT_FORM_VALUE';
export const UPDATE_GROUP_DISPLACEMENT_ROOM_NUMBER = 'app/formData/UPDATE_GROUP_DISPLACEMENT_ROOM_NUMBER';
export const UPDATE_GROUP_DISPLACEMENT_ADR_DATA = 'app/formData/UPDATE_GROUP_DISPLACEMENT_ADR_DATA';
export const UPDATE_GROUP_DISPLACEMENT_FORECAST_DATA = 'app/formData/UPDATE_GROUP_DISPLACEMENT_FORECAST_DATA';
export const UPDATE_GROUP_DISPLACEMENT_ALL_FORECASTS = 'app/formData/UPDATE_GROUP_DISPLACEMENT_ALL_FORECASTS';
export const UPDATE_GROUP_DISPLACEMENT_ADDITIONAL_SPEND = 'app/formData/UPDATE_GROUP_DISPLACEMENT_ADDITIONAL_SPEND';
export const GROUP_DISPLACEMENT_CALCULATE_MIN_RATE = 'app/formData/GROUP_DISPLACEMENT_CALCULATE_MIN_RATE';
export const UPDATE_GROUP_DISPLACEMENT_ADDITIONAL_SPEND_SECTION =
    'app/formData/UPDATE_GROUP_DISPLACEMENT_ADDITIONAL_SPEND_SECTION';
export const GROUP_DISPLACEMENT_RESET_FORECASTS = 'app/formData/GROUP_DISPLACEMENT_RESET_FORECASTS';
export const UPDATE_GROUP_DISPLACEMENT_NORMAL_SPEND = 'app/formData/UPDATE_GROUP_DISPLACEMENT_NORMAL_SPEND';

export const RESET_FORM = 'app/formData/RESET_FORM';

export const LOAD_SAVE = 'app/formData/LOAD_SAVE';
export const LOAD_SAVE_START = 'app/formData/LOAD_SAVE_START';
export const LOAD_SAVE_SUCCESS = 'app/formData/LOAD_SAVE_SUCCESS';
export const LOAD_SAVE_ERROR = 'app/formData/LOAD_SAVE_ERROR';
export const RESET_LOADED_SAVE_STATE = 'app/formData/RESET_LOADED_SAVE_STATE';

export const FETCH_SAVES = 'app/formData/FETCH_SAVES';
export const FETCH_SAVES_START = 'app/formData/FETCH_SAVES_START';
export const FETCH_SAVES_SUCCESS = 'app/formData/FETCH_SAVES_SUCCESS';
export const FETCH_SAVES_ERROR = 'app/formData/FETCH_SAVES_ERROR';
export const RESET_SAVES_STATE = 'app/formData/RESET_SAVES_STATE';

export const SAVE_FORM = 'app/formData/SAVE_FORM';
export const SAVE_FORM_START = 'app/formData/SAVE_FORM_START';
export const SAVE_FORM_SUCCESS = 'app/formData/SAVE_FORM_SUCCESS';
export const SAVE_FORM_ERROR = 'app/formData/SAVE_FORM_ERROR';
export const RESET_FROM_SAVING_STATE = 'app/formData/RESET_FROM_SAVING_STATE';
